/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190729 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { Resetable } from '../../resetter/resetable';
import { IMSObjectType } from 'src/app/_model/ims-object';
import { ObjectIdLabelEntry } from '../logic/object-id-label.service';

@Injectable()
export abstract class ObjectIdLabelDaoService implements Resetable {
  public abstract saveObjectIdLabelsData(
    objectIdLabelsData: ObjectIdLabelEntry[],
    objRef: IMSObjectType
  ): Promise<void>;
  public abstract getObjectIdLabelsData(objRef: IMSObjectType): Promise<ObjectIdLabelEntry[]>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
